import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  AiSearchResponse,
  SaveCollectionRequest,
  SaveCollectionResponse,
} from 'src/app/models/ai-search';

// Public AI-search endpoint lives on the web backend (same host as the legacy
// REST API), NOT under /admin. environment.endpoints.webBackend already points
// at the dev/prod host with the /api/v1 prefix. The endpoint is public — no auth
// header is required.
const BASE = environment.endpoints.webBackend;

@Injectable({ providedIn: 'root' })
export class AiSearchService {
  constructor(private readonly http: HttpClient) {}

  // Exact-match (case-insensitive) search over query titles and asset labels.
  // limit is clamped server-side (<=0 -> 100, >200 -> 200).
  search(query: string, limit: number = 50): Observable<AiSearchResponse> {
    return this.http.post<AiSearchResponse>(`${BASE}/ai-search/search`, { query, limit });
  }

  // Saves the selected search assets as a new collection. Backend rejects (400)
  // any asset missing title / portrait_url / landscape_url, and an empty assets
  // array. Empty collection title falls back to "AI Collection" server-side.
  saveCollection(body: SaveCollectionRequest): Observable<SaveCollectionResponse> {
    return this.http.post<SaveCollectionResponse>(`${BASE}/ai-search/save-collection`, body);
  }
}
